import type { ReactNode, Ref } from "react";

import { SectionCard } from "./SectionCard";
import { Spinner } from "./Spinner";
import { Text } from "./Text";

interface CollectionEmptyStateProps {
  children: ReactNode;
  presentation?: "surface" | "compact";
}

export function CollectionEmptyState({ children, presentation = "surface" }: CollectionEmptyStateProps): ReactNode {
  if (presentation === "compact") {
    return <span className="block p-space-lg pb-space-xl">{children}</span>;
  }

  return (
    <SectionCard>
      <Text as="p">{children}</Text>
    </SectionCard>
  );
}

interface CollectionLoadingStateProps {
  ref?: Ref<HTMLDivElement>;
  show?: boolean;
}

export function CollectionLoadingState({ ref, show = true }: CollectionLoadingStateProps): ReactNode {
  return (
    <div className="flex min-h-control-xl items-center justify-center p-space-sm" ref={ref}>
      {show && <Spinner size="md" />}
    </div>
  );
}
